import * as types from "./mutation-type";

export default {
    [types.SET_COMPANY](state, payload) {
        state.company = payload
    },
    [types.SET_SOCIALS](state, payload) {
        state.socials = payload
    },
    [types.SET_FACEBOOK_PIXEL](state, payload) {
        state.facebookPixel = payload
    },
    [types.SET_GOOGLE_ADS](state, payload) {
        state.googleAds = payload
    },
    [types.SET_COMPANY_SETTINGS](state, payload) {
        state.companySettings = payload
    },
}
